export default __webpack_public_path__ + "static/media/View.2ca4135c.svg";